export const HEADER_TITLE = 'Marketplace';
export const HEADER_DESCRIPTION = `
<h5>Take your business to the next level with our specially chosen partner services and Virgin Money accounts.
<br>
<br>
<br>
<span style="color: var(--color-secondary)">The information on this page is not financial advice.</span>
</h5>
`;
export const HEADER_IMAGE = '/ui/product-marketplace-webapp/landing_page_header.png';

export const TILES_TP_TITLE = 'Specialists at your service';
export const TILES_TP_DESCRIPTION = 'Select from the specialist brands below to find out how they could benefit your business.';
export const TILES_VM_TITLE = "Pick from Virgin Money's products";
export const TP_CAROUSEL_TITLE = 'Our chosen partners';
export const TP_CAROUSEL_DESCRIPTION = 'Unlock a range of services from expense management to flexible insurance and invoice financing with our dedicated partner companies.';
export const SAVINGS_CAROUSEL_TITLE = 'Business savings accounts';
export const SAVINGS_CAROUSEL_DESCRIPTION = `Help your business grow with some of our instant access and notice savings accounts. <a class="bg-dark" style="fontWeight: inherit; textDecorationThickness: from-font;" href="https://uk.virginmoney.com/business/savings">See our full range of savings products.</a>`;
export const LENDING_CAROUSEL_TITLE = 'Discover our lending products';
export const LENDING_CAROUSEL_DESCRIPTION = "We're here for you, whether transacting overseas, smoothing your cash flow or helping with an exciting opportunity.";

export const TP_CAROUSEL_CTA_TEXT = 'Find out more';
export const SAVINGS_CAROUSEL_CTA_TEXT = 'View more';
export const LENDING_CAROUSEL_CTA_TEXT = 'View more';

export const MP_LANDING_PAGE_CONTAINER_DATA_TESTID = 'mp-lp-container';
